import { useQuery, useMutation } from "@tanstack/react-query";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";


const addDeduction = async (input) => {
  const data = await http_payroll.post(Api_EndPoints.PayrollDeduction , input);
  return data;
};

export const useAddDeductionMutation = () => {
  return useMutation({
    mutationFn: addDeduction,
  });
};

const updateDeduction = async (input) => {
  const data = await http_payroll.put(Api_EndPoints.PayrollDeduction, input);
  return data;
};

export const useUpdateDeductionMutation = () => {
  return useMutation({
    mutationFn: updateDeduction,
  });
};



const deleteDeduction = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.PayrollDeduction}?&code=${code}&CompanyCode=${companyCode}`
  );
  return data;
};

export const useDeletePayrollDeductionMutation = () => {
  return useMutation({
    mutationFn: deleteDeduction,
  });
};
